import { environment } from '@/_shared/configuration/env';
import { payloadToQueryParamsUrl } from '@/_shared/helpers';
import { GetPaymentsParams } from '../types';

export const API_PAYMENTS_GET = (payload: GetPaymentsParams, org: string) => {
  const baseUrl = `${environment.VITE_APP_HOST_GENERIC_API_BASE}/api/payments/v1/organizations/${org}/get-payments`;
  return payloadToQueryParamsUrl(payload, baseUrl);
};

export const API_GET_DOWNLOAD_PAYMENT_RECEIPT = (paymentId: string) => {
  const baseUrl = `${environment.VITE_APP_HOST_GENERIC_API_BASE}/api/payments/v1/receipt/${paymentId}`;
  return baseUrl;
};
export const API_PENDING_PAYMENTS_GET = (payload: GetPaymentsParams, org: string) => {
  const baseUrl = `${environment.VITE_APP_HOST_GENERIC_API_BASE}/api/payments/v1/organizations/${org}/get-payments/pending`;
  return payloadToQueryParamsUrl(payload, baseUrl);
};

export const API_PAYMENTS_CREATE = `${environment.VITE_APP_HOST_GENERIC_API_BASE}/api/payments/v1/create`;
